import React, { useState, useEffect } from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ShoppingBasketTwoToneIcon from "@material-ui/icons/ShoppingBasketTwoTone";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";

// Components
import JcPortalSalesOrderHQTable from "./JcPortalSalesOrderHQTable";
import JcOnlineShopPaymentTable from "./JcOnlineShopPaymentTable";

//React Router (for getting parameters)
import { useParams, NavLink } from "react-router-dom";

//number format plugin
import numeral from "numeral";

import { PDFDownloadLink } from "@react-pdf/renderer";
import { JcOnlineOrderPdf } from "../../../components/PDF/JcOnlineOrderPdf";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MessageBox from "../../../components/MessageBox/MessageBox";
import LoadingModal from "../../../components/Modal/LoadingModal";
//cookies
import { get_cookies, isLoggedIn, timeZoneChanger } from "../../../components/Cookies/Cookies";
import Preloader from "../../../components/Preloader/Preloader";
import CountryTagOrderTable from "./CountryTagOrderTable";
import { PdfDocument } from "../../../components/PDF/AccountUpgradeReleasePdf";
import AccountUpgradeTable from "./AccountUpgradeTable";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
const useStyles = makeStyles({
  card: {
    marginBottom: "1rem",
  },
  cardHeader: {
    borderBottom: "1px solid #33993312",
    padding: "1.3rem 24px 2rem 24px",
  },
  title: {
    marginTop: "0",
    color: "#339933",
    fontWeight: "700",
    fontSize: "1.1rem",
  },
  subTitle: {
    fontSize: "0.8rem",
    marginBottom: "0.5rem",
    fontWeight: "700",
    textTransform: "uppercase",
    color: "#9f9f9f",
  },
  infoContainer: {
    marginBottom: "2rem",
    backgroundColor: "#33993312",
    padding: "1rem",
    border: "1.5px solid #33993312",
    borderRadius: "5px",
  },
  infoTitle: {
    fontWeight: "700",
    fontSize: "14px",
  },
  infoContent: {
    fontSize: "14px",
  },
  buttonContainer: {
    textAlign: "right",
    "& button": {
      marginLeft: "0.5rem !important",
    },
  },
  wayBillbuttonContainer: {
    textAlign: "right",
    "& button": {
      marginLeft: "0.5rem !important",
    },
    marginTop: "1rem !important",
    marginRight: "1rem !important",
  },
  infoTotal: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: "1rem",
  },
  infoTotalItem: {
    padding: "0.5rem 1rem",
    border: "1px solid #33993312",
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
    marginBottom: "0.5rem",
    fontWeight: "700",
  },
  infoTotalIcon: {
    marginRight: "0.5rem",
    color: "#4caf50 !important",
  },
  textarea: {
    width: "100%",
    marginTop: "1rem",
  },
});

const AccountUpgradeDetails = () => {
  const { id, useridNo,mainref } = useParams();
  const [soInfo, setSoInfo] = useState(null);
  const classes = useStyles();
    const location = useLocation();
  const { main_reference_no } = location.state || {};

  const [items, setItems] = useState([]); //data to display in item table
  const [payments, setPayments] = useState([]); //data to display in item table
  const [showPDF, setShowPdf] = useState(false);

  const [shipping, setShipping] = useState([]);
  const [warehouse, setWarehouse] = useState([]);
  const [upgDetails, setUpgDetails] = useState([]);
  const [packages, setPackage] = useState([]);
  const [shippingId, setShippingId] = useState("");
  const [shippingName, setShippingName] = useState("");
  const [warehouseId, setWarehouseId] = useState("");
  const [refno, setRefno] = useState("");
  const [isReleased, setIsReleased] = useState(false);
  const [grandtotal, setGrandTotal] = useState(0);
  const [releasedDate, setReleasedDate] = useState(null);
   const [places, setPlaces] = useState([]);
  let history = useHistory();

  //Message Box
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("Empty");
  const [msgType, setMsgType] = useState("success");
  //Message Box EOF
  //state for managing loading modal
  const [showModal, setShowModal] = useState(false);
  //state for disabling/enabling button
  const [btnDisabled, setBtnDisabled] = useState(true);
    const [selectedDate, setSelectedDate] = useState(null);
      const [hqlink, setHqLink] = useState("");
      const [supplierId, setSupplierId] = useState("");
  // componentDidMount / document.ready ?
  useEffect(() => {
    // console.log('flag',useridNo);
    // console.log('main',mainref);
    data();
    getHqLink();
  }, []);

  useEffect(() => {
    timeZoneChanger(setSelectedDate);
  }, []);

  const x = 0;
  useEffect(() => {
    //
    isLoggedIn();
  }, [x]);

  const selectShippingProps = {
    options: shipping,
    getOptionLabel: (option) => option.description,
  };

      const selectPurchaseProps = {
    options: places,
    getOptionLabel: (option) => option.branchname,
  };

  const selectLocationProps = {
    options: warehouse,
    getOptionLabel: (option) => option.description,
  };

  const headers = {
    "Content-Type": "multipart/form-data",
  };

  useEffect(() => {
    if (warehouseId && soInfo) {
      setBtnDisabled(false); // re-enable
    } else {
      setBtnDisabled(true); // re-enable
    }
  }, [refno, shippingId, warehouseId, soInfo]);

  useEffect(() => {
    // console.log('is',get_cookies('is_operational'));
    //   console.log('hq',hqlink);
    if(get_cookies('is_operational') == 1 && hqlink){
   setBtnDisabled(false); 
    }else{
         setBtnDisabled(false); 
    }
  }, [hqlink])
  

  const data = async () => {
    await axios
      .get(process.env.REACT_APP_API_URL + "get_details_account", {
        params: {
          idno: id,
          jc_u_idno: get_cookies("branchidno"),
          username: get_cookies("username"),
          main_reference_no:mainref,
        },
      })
      .then((res) => {
        // console.log(res.data);
        setPackage(res.data.countrytag_package);
        setItems(res.data.countrytag_packagesitem);
        setSoInfo(res.data.distributor_info);
        setUpgDetails(res.data.countrytag_upgrade_details);
        setShipping(res.data.countrytag_shipping);
        setGrandTotal(parseFloat(res.data.countrytag_shipping.shipping_fee) + parseFloat(res.data.countrytag_upgrade_details.amount));
        // setWarehouse(res.data.get_location);
        // console.log('??',res.data.is_released);
        if (res.data.is_releasedbyhq == null && res.data.is_hq_released == null) {
          setIsReleased(true);
        } else {
          setIsReleased(false);
                
                    setReleasedDate(res.data.is_released.date_released);
                    setShowPdf(true);
        }
        getWarehouse();

        // setPayments(res.data.data.customer_alloc);
        // if (res.data.data.order_details) {
        //   setShowPdf(true);
        // }
        //total_payment = res.data.data.cp_payments+res.data.data.b1t1_payments+res.data.data.ppv_payments+res.data.data.dragonpay_payments+res.data.data.paypanda_payments+res.data.data.asiapay_payments+res.data.data.ipay_payments;
      })
      .catch((error) => {
        // console.log(error.message);
      });
  };

  const getWarehouse = async () => {
		//get data for location/warehouse dropdown
		const res = await axios.get(process.env.REACT_APP_API_URL+'/get_warehouse_list');
		setWarehouse(res.data.data);

	};

        const getHqLink = () => {
        //get data for shipping location dropdown
        const form_data = {
          branchidno: get_cookies("branchidno"),
        };
        const formData = new FormData();
        formData.append("form_data", JSON.stringify(form_data));
        const apiUrl = process.env.REACT_APP_API_URL + "getHqLink";
        axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      const apiData = res.data.data || [];
    
          const staticData = {
      id: 0,
      idno: "MAINHQ",
      branchname: "JC Premiere Business International",
        supplier_id: 0,
          };
    
      
      setPlaces([staticData, ...apiData]);
        });
      };
  const release_online_orders = async () => {
    setBtnDisabled(true); // disable button to avoid multiple saves
    setShowModal(true); //show loading/please wait modal

        if(get_cookies('is_operational')== 0){
          if(hqlink !="MAINHQ"){
          if(supplierId == "" || supplierId == null || hqlink == null){
                    setShowModal(false);
              setShowMsgBox(true);
            setMsg("Please Select Purchase From");
            setMsgType("warning");
            setTimeout(() => {
              setShowMsgBox(false);
              setBtnDisabled(false); // re-enable
            }, 2500);
            return;
          }
          }
        }
    const formData = new FormData();
    // drno:8992
    // locid:8
    // shipid:1
    // shipping_name:TOKTOK
    // refnum:8ty87t8976tg8gh87u
    // totalamt:595
    //jc_u_idno:DAVAOHQ
    formData.append("idno", soInfo.idno);
    formData.append("itemlocid", warehouseId);
    formData.append("reference_no", upgDetails.reference_no);
    formData.append("username", get_cookies("username"));
    formData.append("jc_u_idno", get_cookies("branchidno"));
    formData.append("trandate", selectedDate);
    formData.append("idnoofbranch", shipping.branchcode);
    formData.append("packageid", packages.packageid);
    formData.append("hqlink", hqlink);
    formData.append("supplierId", supplierId);
     formData.append("shipping_fee", shipping.shipping_fee);

    await axios
      .post(process.env.REACT_APP_API_URL + "release_package_account", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function (res) {
        // console.log('result',res);
        setShowModal(false); //hide loading/please wait modal
        setShowMsgBox(true);
        setMsg("Successfully Released#" + upgDetails.reference_no);
        setMsgType("success");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
          history.push("/WholesaleMenu");
        }, 2000);
      })
      .catch(function (error) {
        setShowModal(false); //hide loading/please wait modal
        setShowMsgBox(true);
        setMsg("Something went wrong: " + error);
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
        }, 2500);
      });
  };

  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <ShoppingCartIcon />
        </div>
        {/* <img src={logo} width="100" height="50" alt="jc logo"/> */}
        <NavLink to={"/sales"}>
          <h2 style={{ color: "black" }}>Wholesale</h2>
        </NavLink>
        <ArrowForwardIosIcon
          style={{ paddingLeft: "10px", paddingRight: "10px" }}
        />
        <NavLink to={"/sales/account-upgrade"}>
          <h2 style={{ color: "black" }}>Paid Account Upgrade Summary</h2>
        </NavLink>
        <ArrowForwardIosIcon
          style={{ paddingLeft: "10px", paddingRight: "10px" }}
        />
        <h2> Paid Account Upgrade Summary Details</h2>
      </div>
      {soInfo ? (
        <div className="page-container">
          <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType} />
          <LoadingModal showModal={showModal} />
          <Card className={classes.card}>
            <div className={classes.cardHeader}>
              <Grid
                container
                spacing={0}
                style={{ justifyContent: "flex-end" }}
              >
                {/* <Grid item xs={8}>
                  <div className={classes.title}>Online Sales Order View</div>
                </Grid> */}
                <Grid item xs={2} style={{ textAlign: "right" }}></Grid>
                <Grid item xs={2} className={classes.buttonContainer}></Grid>
              </Grid>
            </div>
            <CardContent>
              {soInfo ? (
                <Grid container spacing={3}>
                                    {releasedDate !== null ? (
                    <div
                      style={{
                        backgroundColor: "#dff0d8",
                        color: "#3c763d",
                        padding: "12px 16px",
                        borderRadius: "4px",
                        width: "100%",
                        border: "1px solid #d6e9c6",
                        marginBottom: "16px",
                      }}
                    >
                      <strong>Note:</strong> This Wholesale Set has already been
                      released.
                    </div>
                  ) : null}
                  <Grid item xs={12} sm={12} md={12} lg={5}>
                    <div className={classes.infoContainer}>
                      <Grid
                        container
                        justifyContent="space-between"
                        spacing={2}
                      >
                        <Grid item xs={12} sm={12}>
                          <Grid container spacing={3}>
                            <Grid
                              item
                              xs={12}
                              sm={4}
                              className={classes.infoTitle}
                            >
                              ID No:
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={8}
                              className={classes.infoContent}
                            >
                              {soInfo.idno}
                            </Grid>
                          </Grid>
                          <Grid container spacing={3}>
                            <Grid
                              item
                              xs={12}
                              sm={4}
                              className={classes.infoTitle}
                            >
                              Name:
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={8}
                              className={classes.infoContent}
                            >
                              {soInfo.fname} {soInfo.mname || " "}{" "}
                              {soInfo.lname}
                            </Grid>
                          </Grid>
                           <Grid container spacing={3}>
                            <Grid
                              item
                              xs={12}
                              sm={4}
                              className={classes.infoTitle}
                            >
                              Contact Number:
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={8}
                              className={classes.infoContent}
                            >
                              {soInfo.conno}
                            </Grid>
                          </Grid>
                                                     <Grid container spacing={3}>
                            <Grid
                              item
                              xs={12}
                              sm={4}
                              className={classes.infoTitle}
                            >
                              Email:
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={8}
                              className={classes.infoContent}
                            >
                              {soInfo.email}
                            </Grid>
                          </Grid>
                                                  <Grid container spacing={3}>
                                                      <Grid
                                                        item
                                                        xs={12}
                                                        sm={4}
                                                        className={classes.infoTitle}
                                                      >
                                                        Shipping Details:
                                                      </Grid>
                                                      <Grid
                                                        item
                                                        xs={12}
                                                        sm={8}
                                                        className={classes.infoContent}
                                                      >
                                                      </Grid>
                                                    </Grid>
                                                    <Grid container spacing={3}>
                                                      <Grid
                                                        item
                                                        xs={12}
                                                        sm={4}
                                                        className={classes.infoTitle}
                                                      >
                                                        Delivery Type:
                                                      </Grid>
                                                      {shipping.shipping_fee == 0?                                                      <Grid
                                                        item
                                                        xs={12}
                                                        sm={8}
                                                        className={classes.infoContent}
                                                      >
                            {'Pick Up'}
                                                      </Grid>:                                                      <Grid
                                                        item
                                                        xs={12}
                                                        sm={8}
                                                        className={classes.infoContent}
                                                      >
                            {'Delivery'}
                                                      </Grid>}

                                                    </Grid>
                                                    {shipping.shipping_fee == 0?<Grid container spacing={3}>
                                                      <Grid
                                                        item
                                                        xs={12}
                                                        sm={4}
                                                        className={classes.infoTitle}
                                                      >
                                                        Pickup Location:
                                                      </Grid>
                                                      <Grid
                                                        item
                                                        xs={12}
                                                        sm={8}
                                                        className={classes.infoContent}
                                                      >
                            {shipping.branchname ? shipping.branchname : shipping.branchcode}
                                                      </Grid>
                                                    </Grid>:null}   

                                                    <Grid container spacing={3}>
                                                      <Grid
                                                        item
                                                        xs={12}
                                                        sm={4}
                                                        className={classes.infoTitle}
                                                      >
                                                        Address:
                                                      </Grid>
                                                      <Grid
                                                        item
                                                        xs={12}
                                                        sm={8}
                                                        className={classes.infoContent}
                                                      >
                            {shipping.address}
                                                      </Grid>
                                                    </Grid>

                                                        {shipping.shipping_fee == 0 ?null:<>
                                                          <Grid container spacing={3}>
                                                      <Grid
                                                        item
                                                        xs={12}
                                                        sm={4}
                                                        className={classes.infoTitle}
                                                      >
                                                        City:
                                                      </Grid>
                                                      <Grid
                                                        item
                                                        xs={12}
                                                        sm={8}
                                                        className={classes.infoContent}
                                                      >
                            {shipping.city}
                                                      </Grid>
                                                    </Grid>
                                                    <Grid container spacing={3}>
                                                      <Grid
                                                        item
                                                        xs={12}
                                                        sm={4}
                                                        className={classes.infoTitle}
                                                      >
                                                        Country:
                                                      </Grid>
                                                      <Grid
                                                        item
                                                        xs={12}
                                                        sm={8}
                                                        className={classes.infoContent}
                                                      >
                            {shipping.country}
                                                      </Grid>
                                                    </Grid>
                                                    <Grid container spacing={3}>
                                                      <Grid
                                                        item
                                                        xs={12}
                                                        sm={4}
                                                        className={classes.infoTitle}
                                                      >
                                                        Postal Code:
                                                      </Grid>
                                                      <Grid
                                                        item
                                                        xs={12}
                                                        sm={8}
                                                        className={classes.infoContent}
                                                      >
                            {shipping.postal_code}
                                                      </Grid>
                                                    </Grid></>}


                                                    <Grid container spacing={3}>
                                                      <Grid
                                                        item
                                                        xs={12}
                                                        sm={4}
                                                        className={classes.infoTitle}
                                                      >
                                                        Wholesale Set Details:
                                                      </Grid>
                                                      <Grid
                                                        item
                                                        xs={12}
                                                        sm={8}
                                                        className={classes.infoContent}
                                                      >
                          
                                                      </Grid>
                                                    </Grid>
                                                    <Grid container spacing={3}>
                                                      <Grid
                                                        item
                                                        xs={12}
                                                        sm={4}
                                                        className={classes.infoTitle}
                                                      >
                                                        Set Selected:
                                                      </Grid>
                                                      <Grid
                                                        item
                                                        xs={12}
                                                        sm={8}
                                                        className={classes.infoContent}
                                                      >
                              {packages.map((pkg, index) => (
  <div key={index}>{pkg.package_name}</div>
))}
                                                      </Grid>
                                                    </Grid>
                          {/* <Grid container spacing={2}>
                            <Grid
                              item
                              xs={12}
                              sm={4}
                              className={classes.infoTitle}
                            >
                              Contact No:
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={4}
                              className={classes.infoContent}
                            >

                              <Grid
                                item
                                xs={12}
                                sm={4}
                                className={classes.infoContent}
                              >
                                {upgDetails.conno}
                              </Grid>
                            </Grid>

                          </Grid>
                          <Grid container spacing={3}>
                            <Grid
                              item
                              xs={4}
                              sm={4}
                              className={classes.infoTitle}
                            >
                              Address:
                            </Grid>
                            <Grid
                              item
                              xs={4}
                              sm={4}
                              className={classes.infoContent}
                            >
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                className={classes.infoContent}
                              >
                                {upgDetails.address}
                              </Grid>
                            </Grid>
                          </Grid> */}
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={5}>
                    <div className={classes.infoContainer}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={4} className={classes.infoTitle}>
                          Transaction Date:
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={8}
                          className={classes.infoContent}
                        >
                          {upgDetails.date_created} (Philippine Time)
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={4} className={classes.infoTitle}>
                          Payment Date:
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={8}
                          className={classes.infoContent}
                        >
                          {upgDetails.ph_date_paid} (Philippine Time)<br/>
                          {get_cookies('country') == "Philippines" ? null :<> {upgDetails.date_paid} ({get_cookies('country')} Time)</>}  
             
                        </Grid>
                      </Grid>
      
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={4} className={classes.infoTitle}>
                          Payment Via:
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={8}
                          className={classes.infoContent}
                        >
                                  {upgDetails.payment_type === "OTCHQ" ? "Over the counter" : upgDetails.payment_type}
                        </Grid>
                      </Grid>
                      {shipping.shipping_fee != 0 ?                     <Grid container spacing={3}>
                        <Grid item xs={12} sm={4} className={classes.infoTitle}>
                          Shipping Fee:
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={8}
                          className={classes.infoContent}
                        >
                                  {get_cookies('curcode') == "PHP"?numeral(shipping.shipping_fee_php).format('0,0.00') + " PHP": numeral(shipping.shipping_fee).format('0,0.00') + " "+ upgDetails.curcode} 
                        </Grid>
                      </Grid>:null}
                      {upgDetails.payment_type === "PayPanda"? <Grid container spacing={3}>
                        <Grid item xs={12} sm={4} className={classes.infoTitle}>
                          {upgDetails.payment_type} Reference No:
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={8}
                          className={classes.infoContent}
                        >
                                  {upgDetails.payment_ref}
                        </Grid>
                      </Grid>:null}

                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={4} className={classes.infoTitle}>
                          Reference No:
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={8}
                          className={classes.infoContent}
                        >
                          {upgDetails.reference_no}
                        </Grid>
                      </Grid>
                      <Grid container spacing={3}>
                        <Grid item xs={12} sm={4} className={classes.infoTitle}>
                          Main Reference No:
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={8}
                          className={classes.infoContent}
                        >
                          {upgDetails.main_reference_no}
                        </Grid>
                      </Grid>
                      {/* <Grid container spacing={3}>
                        <Grid item xs={12} sm={4} className={classes.infoTitle}>
                          PayPanda Reference No:
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={8}
                          className={classes.infoContent}
                        >
                          {upgDetails.payment_ref}
                        </Grid>
                      </Grid> */}
                      {/* <Grid container spacing={3}>
                            <Grid
                              item
                              xs={4}
                              sm={4}
                              className={classes.infoTitle}
                            >
                              Account Type:
                            </Grid>
                            <Grid
                              item
                              xs={4}
                              sm={4}
                              className={classes.infoContent}
                            >
                              From
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                className={classes.infoContent}
                              >
                                {upgDetails.old_atype}
                              </Grid>
                            </Grid>
                            <Grid
                              item
                              xs={4}
                              sm={4}
                              className={classes.infoContent}
                            >
                              To
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                className={classes.infoContent}
                              >
                                {upgDetails.new_atype}
                              </Grid>
                            </Grid>
                          </Grid> */}
                    </div>
                  </Grid>
                  {/* <Grid item xs={12} sm={12} md={12} lg={5}>
                    <div className={classes.infoContainer}>
                      <Grid
                        container
                        justifyContent="space-between"
                        spacing={2}
                      >
                        <Grid item xs={6} sm={6}>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            className={classes.infoTitle}
                          >
                            Shipping Details:
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={4}
                            className={classes.infoTitle}
                          >
                            Delivery Type:
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={8}
                            className={classes.infoContent}
                          >
                            Pick Up
                          </Grid>
                        </Grid>
                        <Grid item xs={6} sm={6}>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            className={classes.infoTitle}
                          >
                            Wholesale Set Details:
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={4}
                            className={classes.infoTitle}
                          >
                            Set Selected:
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={8}
                            className={classes.infoContent}
                          >
                            {packages.package_name}
                          </Grid>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid> */}
                </Grid>
              ) : (
                <></>
              )}

              <h4>Item Details</h4>
              <AccountUpgradeTable items={items} />
{/* 
              {shipping ? (
                <div className={classes.infoTotal}>
                  <div className={classes.infoTotalContent}>
                  <div className={classes.infoTotalItem}>
                      <ShoppingCartTwoToneIcon
                        className={classes.infoTotalIcon}
                      />
                      {"Upgrade Fee: " + numeral(upgDetails.amount).format("0,0.00")}
                    </div>
                    <div className={classes.infoTotalItem}>
                      <LocalShippingTwoToneIcon
                        className={classes.infoTotalIcon}
                      />
                      {"Shipping: " +
                        numeral(shipping.shipping_fee).format("0,0.00")}
                    </div>
                    <div className={classes.infoTotalItem}>
                      <ShoppingCartTwoToneIcon
                        className={classes.infoTotalIcon}
                      />
                      {"Total: " + numeral(grandtotal).format("0,0.00")}
                    </div>
                    <div className={classes.infoTotalItem}>
                      {"Note: All payments are converted to PHP"}
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )} */}

              {isReleased == true? (
                <Grid container spacing={1}>
                  <Grid item xs={12} lg={6}>
                    <Autocomplete
                      {...selectLocationProps}
                      id="auto-complete-2"
                      autoComplete
                      includeInputInList
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          margin="normal"
                          label="Warehouse Location"
                          variant="outlined"
                        />
                      )}
                      onChange={(event, newValue) => {
                        if (!newValue == "" || !newValue == null) {
                          //console.log(newValue.description);
                          setWarehouseId(newValue.id);
                        }
                      }}
                    />
                  </Grid>
                  {get_cookies('is_operational') == 0?
                  <Grid item xs ={12} lg={6}>
                                        <Autocomplete
                                          {...selectPurchaseProps}
                                          style={{ marginTop: "1rem" }}
                                          id="auto-complete-1"
                                          autoComplete
                                          includeInputInList
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              label="Select Purchase From"
                                              variant="outlined"
                                            />
                                          )}
                                          onChange={(event, newValue) => {
                                            if (!newValue == "" || !newValue == null) {
                                              //console.log(newValue.description);
                                              setHqLink(newValue.idno);
                                               setSupplierId(newValue.supplier_id);
                                            } else {
                                              setHqLink(null);
                                              setSupplierId(null);
                                            }
                                          }}
                                        />
                  </Grid>:null}

                </Grid>
              ) : (
                <></>
              )}
            </CardContent>
          </Card>
          <div className={classes.buttonContainer}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                {showPDF && (
                  <PDFDownloadLink
                    document={
                      <PdfDocument
                        headers={upgDetails}
                        soInfo={soInfo}
                        items={items}
                        packages={packages}
                        country={get_cookies('country')}
                      />
                    }
                    fileName={"AccountUpgrade#" + upgDetails.reference_no + ".pdf"}
                    style={{
                      textDecoration: "none",
                      padding: "6px 8px 10px",
                      color: "#fff",
                      display: "inline-block",
                      marginBottom: "7px",
                      fontFamily: "Ubuntu",
                      backgroundColor: "#339933",
                      border: "1px solid #339933",
                      borderRadius: "4px",
                    }}
                  >
                    {({ blob, url, loading, error }) =>
                      loading ? "Loading document..." : "Print"
                    }
                  </PDFDownloadLink>
                )}
                {isReleased != false ? (
                  <Button
                    disabled={btnDisabled}
                    onClick={() => {
                      release_online_orders();
                    }}
                    variant="contained"
                    color="primary"
                  >
                    Release
                  </Button>
                ) : (
                  <></>
                )}
              </Grid>
            </Grid>
          </div>
        </div>
      ) : (
        <Preloader />
      )}
    </div>
  );
};

export default AccountUpgradeDetails;
